import { useState } from 'react';

export default function HomePage() {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      title: "青年訓練及小組活動",
      description: "為學生提供多元化的青年訓練及小組訓練，培養團隊合作、領導能力和創新思維，透過專業的青年訓練課程促進學生全面發展",
      features: ["團隊建設", "領導力培訓", "創意思維", "溝通技巧"]
    },
    {
      title: "教育局12個價值觀元素",
      description: "本中心專注推動教育局12大價值觀教育（堅毅、尊重、責任、國民身份認同、承擔、誠信、仁愛、守法、同理心、勤勞、團結、孝親），透過多元沉浸式學習模式進行青年訓練",
      features: ["主題工作坊：桌遊、歷奇、藝術創作、情境劇場、動漫", "彈性實施方案：週會、入班小組、半天工作坊、訓練營", "專業設計：緊貼學生發展需要，結合體驗與反思", "價值觀教育"]
    },
    {
      title: "Kimochis情緒管理課程",
      description: "Kimochis®教材由美國教育專家Ellen P. Dodge設計，曾獲多個國際獎項，於美國及澳洲廣泛為學校及家長使用",
      features: ["情緒認知", "社交技巧", "自我管理", "同理心培養"]
    },
    {
      title: "SEN特殊學習需要支援",
      description: "針對特殊學習需要學生設計，透過結構化桌遊活動在安全有趣的環境中自然練習輸輸、規則理解、情緒調適及團隊協作",
      features: ["藝術治療", "社交技能發展訓練", "升中適應", "SEN桌遊社交課程"]
    },
    {
      title: "正向心理學服務",
      description: "基於正向心理學理論，透過多元化活動培養學生的正向思維和積極人生態度",
      features: ["認識優點特質", "正向情緒培養", "幸福感提升", "成長型思維"]
    },
    {
      title: "家長講座",
      description: "專業的家長教育講座，協助家長了解子女成長需要，建立良好親子關係",
      features: ["親子溝通", "教育方法", "心理健康", "學習支援"]
    },
    {
      title: "教師訓練",
      description: "為教育工作者提供專業發展培訓，提升教學效能和學生管理技巧",
      features: ["教學技巧", "課堂管理", "學生輔導", "專業發展"]
    },
    {
      title: "企業培訓",
      description: "為企業提供員工培訓服務，提升團隊效能和企業競爭力",
      features: ["團隊協作", "領導管理", "溝通技巧", "創新思維"]
    }
  ];

  const testimonials = [
    {
      name: "陳校長",
      school: "聖保羅小學",
      content: "青年創變的價值觀教育課程非常實用，學生在品德培養方面有顯著進步。"
    },
    {
      name: "李老師",
      school: "培正中學",
      content: "Kimochis情緒管理課程幫助學生更好地理解和表達情感，課堂氣氛更和諧。"
    },
    {
      name: "王家長",
      school: "明愛幼稚園",
      content: "透過12個價值觀元素的學習，我的孩子變得更有責任感和同理心。"
    },
    {
      name: "張老師",
      school: "東華三院小學",
      content: "SEN支援服務幫助我們的特殊學習需要學生更好地融入校園生活，提升了他們的社交能力。"
    }
  ];

  const parentChildActivities = [
    {
      title: "親子歷奇日",
      description: "透過多樣的互動活動和挑戰，親子雙方將有機會一起體驗挑戰與創意，激發創意與合作精神。這是一個絕佳的機會讓家長與孩子建立更親密的回憶！",
      icon: "ri-compass-3-line",
      color: "blue",
      image: "https://public.readdy.ai/ai/img_res/cdae9a3c08d4835589c425421dc03ecd.jpg"
    },
    {
      title: "親子體能遊戲日",
      description: "家長和孩子們一起參加多樣體能挑戰！透過有趣的遊戲和競賽，增進親子關係，讓孩子在運動中學習，這不僅是一次愉快的體驗，也是培養健康生活習慣的絕佳機會！",
      icon: "ri-basketball-line",
      color: "green",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20parents%20and%20children%20playing%20sports%20and%20physical%20games%20together%2C%20family%20fitness%20activities%2C%20fun%20outdoor%20games%20with%20colorful%20equipment%2C%20healthy%20lifestyle%20and%20bonding%20through%20exercise%2C%20happy%20smiling%20Hong%20Kong%20people%20faces%2C%20natural%20lighting&width=400&height=300&seq=parent2&orientation=landscape"
    },
    {
      title: "親子瑜珈",
      description: "親子瑜珈是一個促進親子關係和心靈健康的活動。透過簡單的瑜珈姿勢和呼吸練習，家長和孩子可以共同體驗放鬆和專注，增進身體靈活度和情緒穩定。",
      icon: "ri-heart-pulse-line",
      color: "purple",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20families%20practicing%20yoga%20together%20in%20peaceful%20indoor%20setting%2C%20family%20doing%20yoga%20poses%20on%20mats%2C%20calm%20and%20relaxing%20atmosphere%2C%20mindfulness%20and%20wellness%20activities%20for%20families%2C%20happy%20smiling%20Hong%20Kong%20people%20faces%2C%20natural%20lighting&width=400&height=300&seq=parent3&orientation=landscape"
    },
    {
      title: "親子靜觀活動",
      description: "親子靜觀活動邀請家長和孩子一起探索內心的平靜與專注。透過靜心練習和情緒覺察，這些活動幫助家庭成員如何有效地處理情緒，增進親子關係，並在遊戲中發現彼此的獨特需求與深層的情感聯繫！",
      icon: "ri-mental-health-line",
      color: "pink",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20families%20practicing%20mindfulness%20meditation%20together%2C%20parents%20and%20children%20in%20calm%20meditation%20session%2C%20peaceful%20indoor%20environment%20with%20soft%20lighting%2C%20emotional%20awareness%20and%20bonding%20activities%2C%20happy%20smiling%20Hong%20Kong%20people%20faces%2C%20natural%20lighting&width=400&height=300&seq=parent4&orientation=landscape"
    },
    {
      title: "5種愛的語言親子日",
      description: "專注於幫助單親和孩子理解和表達愛的不同方式。透過互動活動和遊戲，家庭成員可以學習如何有效地表達愛，增進親子關係，並創造更深的情感聯繫！",
      icon: "ri-heart-3-line",
      color: "red",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20families%20expressing%20love%20through%20various%20activities%2C%20family%20bonding%20with%20heart%20symbols%20and%20warm%20interactions%2C%20colorful%20and%20loving%20atmosphere%2C%20emotional%20connection%20and%20communication%2C%20happy%20smiling%20Hong%20Kong%20people%20faces%2C%20natural%20lighting&width=400&height=300&seq=parent5&orientation=landscape"
    }
  ];

  // 新增興趣班和多元化活動
  const interestClasses = [
    {
      title: "泰拳",
      description: "專業泰拳訓練課程，強身健體，提升自信心和紀律性",
      icon: "ri-boxing-line",
      color: "red",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20students%20learning%20Thai%20boxing%20in%20professional%20training%20gym%2C%20young%20people%20in%20fitness%20and%20martial%20arts%20training%2C%20disciplined%20exercise%20environment%2C%20building%20confidence%20and%20strength%2C%20focused%20happy%20Hong%20Kong%20faces%2C%20bright%20lighting&width=300&height=250&seq=class1&orientation=landscape"
    },
    {
      title: "化妝班",
      description: "化妝技巧教學，培養美感和創意表達能力，提升個人形象",
      icon: "ri-palette-line",
      color: "pink",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20students%20in%20makeup%20class%20with%20colorful%20cosmetics%20and%20brushes%2C%20young%20people%20learning%20beauty%20skills%20and%20creative%20expression%2C%20professional%20makeup%20training%20environment%2C%20focused%20happy%20Hong%20Kong%20faces%2C%20bright%20lighting&width=300&height=250&seq=class2&orientation=landscape"
    },
    {
      title: "跳舞Jazz/K-pop",
      description: "流行舞蹈課程，包括Jazz和K-pop舞蹈，培養節奏感和表演能力",
      icon: "ri-music-line",
      color: "purple",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20students%20learning%20K-pop%20and%20Jazz%20dance%20in%20modern%20dance%20studio%2C%20young%20people%20with%20energetic%20dance%20movements%2C%20colorful%20dance%20practice%20room%20with%20mirrors%2C%20focused%20happy%20Hong%20Kong%20faces%2C%20bright%20lighting&width=300&height=250&seq=class3&orientation=landscape"
    },
    {
      title: "各式手工藝",
      description: "多元化手工藝製作，包括扎染、編織、陶藝等，發揮創意潛能",
      icon: "ri-palette-line",
      color: "orange",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20students%20creating%20various%20handicrafts%20including%20tie-dye%2C%20pottery%2C%20and%20crafts%2C%20young%20people%20with%20colorful%20art%20materials%20and%20creative%20workspace%2C%20artistic%20expression%20activities%2C%20focused%20happy%20Hong%20Kong%20faces%2C%20bright%20lighting&width=300&height=250&seq=class4&orientation=landscape"
    },
    {
      title: "和諧粉彩",
      description: "溫和的藝術治療方式，透過粉彩畫作舒緩情緒，培養專注力",
      icon: "ri-brush-line",
      color: "blue",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20students%20in%20peaceful%20pastel%20art%20therapy%20session%2C%20young%20people%20with%20soft%20colorful%20chalk%20pastels%2C%20calming%20artistic%20environment%2C%20creating%20gentle%20artwork%20for%20emotional%20wellness%2C%20focused%20happy%20Hong%20Kong%20faces%2C%20bright%20lighting&width=300&height=250&seq=class5&orientation=landscape"
    },
    {
      title: "六色積木",
      description: "透過積木建構活動，提升空間概念、邏輯思維和創造力",
      icon: "ri-building-blocks-line",
      color: "green",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20children%20building%20creative%20structures%20with%20various%20colored%20blocks%2C%20kids%20with%20colorful%20building%20blocks%20construction%20activity%2C%20educational%20play%20and%20spatial%20learning%2C%20focused%20happy%20Hong%20Kong%20faces%2C%20bright%20lighting&width=300&height=250&seq=class6&orientation=landscape"
    },
    {
      title: "香薰製品手工皂/擴香石/潤唇膏/潤膚霜/蠟燭等/香水",
      description: "學習製作天然香薰產品，培養生活技能和環保意識",
      icon: "ri-leaf-line",
      color: "teal",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20students%20making%20natural%20aromatherapy%20products%20including%20handmade%20soaps%2C%20essential%20oil%20diffusers%2C%20lip%20balms%2C%20and%20candles%20in%20workshop%20setting%20with%20natural%20ingredients%2C%20young%20people%20learning%20crafts%2C%20focused%20happy%20Hong%20Kong%20faces%2C%20bright%20lighting&width=300&height=250&seq=class7&orientation=landscape"
    },
    {
      title: "Boardgame",
      description: "桌遊活動促進社交互動，提升策略思維和團隊合作能力",
      icon: "ri-gamepad-2-line",
      color: "indigo",
      image: "https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20students%20playing%20various%20board%20games%20together%2C%20young%20people%20with%20colorful%20game%20pieces%20and%20cards%20on%20table%2C%20social%20interaction%20and%20strategic%20thinking%20development%2C%20focused%20happy%20Hong%20Kong%20faces%2C%20bright%20lighting&width=300&height=250&seq=class8&orientation=landscape"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="px-6 py-4">
          <div className="flex items-center justify-between max-w-7xl mx-auto">
            <div className="flex items-center space-x-3">
              <div className="w-32 h-32 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/6b3080a7ad87d4828fdf666065d4a97a/47b8cf5cc7d4e26c3fd48cdb40a3e5db.png"
                  alt="青年創變有限公司標誌"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">青年創變有限公司</h1>
                <p className="text-lg text-gray-600">Changemakers Limited</p>
              </div>
            </div>
            <div className="hidden lg:flex items-center space-x-6">
              <a href="#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">服務項目</a>
              <a href="#values" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">價值觀教育</a>
              <a href="#kimochis" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">情緒管理</a>
              <a href="#sen" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">SEN支援</a>
              <a href="#positive-psychology" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">正向心理學</a>
              <a href="#parent-child" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">親子活動</a>
              <a href="#interest-classes" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">興趣班</a>
              <a href="#about" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">關於我們</a>
              <a href="#testimonials" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">客戶見證</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">聯絡我們</a>
            </div>
            <div className="lg:hidden">
              <i className="ri-menu-line text-2xl text-gray-700 cursor-pointer"></i>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-indigo-100 py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="space-y-4">
                <h1 className="text-5xl font-bold text-gray-900 leading-tight">
                  BE THE CHANGE
                  <span className="text-blue-600"> WE WANT TO SEE</span>
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  我們相信改變和成長，致力提供專業的青年訓練、學生培訓及兒童培訓服務，為學校、教師、家長和企業提供全方位的青年訓練及成長支援。透過多元化的青年訓練課程，培養新一代領袖人才。
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="#contact" className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                  聯絡我們
                </a>
              </div>
              <div className="grid grid-cols-3 gap-8 pt-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">500+</div>
                  <div className="text-gray-600">服務學校</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">10+</div>
                  <div className="text-gray-600">年青年訓練經驗</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">50000+</div>
                  <div className="text-gray-600">受惠學生</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20Hong%20Kong%20Chinese%20Asian%20education%20training%20team%20working%20with%20diverse%20students%20in%20modern%20classroom%20setting%2C%20bright%20and%20inspiring%20atmosphere%2C%20teamwork%20and%20collaboration%2C%20educational%20innovation%2C%20professional%20development%2C%20happy%20smiling%20Hong%20Kong%20faces%2C%20natural%20lighting&width=600&height=500&seq=herohk1&orientation=landscape"
                alt="青年創變培訓團隊"
                className="rounded-2xl shadow-2xl object-cover w-full h-[500px] object-top"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-award-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">專業認證</div>
                    <div className="text-sm text-gray-600">教育培訓專家</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Education Section */}
      <section id="values" className="py-20 px-6 bg-gradient-to-br from-orange-50 to-yellow-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">教育局12個價值觀元素</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              透過多元沉浸式學習模式,培養學生的品德修養和正確價值觀
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20Asian%20students%20in%20bright%20classroom%20learning%20about%20moral%20values%20and%20character%20education%20through%20interactive%20workshop%20activities%2C%20colorful%20educational%20posters%20showing%20positive%20values%20concepts%20like%20perseverance%20respect%20responsibility%20integrity%20kindness%2C%20diverse%20group%20of%20happy%20engaged%20Hong%20Kong%20children%20with%20teacher%20guidance%2C%20modern%20educational%20setting%20with%20simple%20clean%20background&width=600&height=400&seq=values2025new&orientation=landscape"
                alt="12個價值觀元素教育"
                className="rounded-2xl shadow-lg object-cover w-full h-96 object-top"
              />
            </div>
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">全面品德教育</h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                本中心專注推動教育局12大價值觀教育，包括堅毅、尊重、責任、國民身份認同、承擔、誠信、仁愛、守法、同理心、勤勞、團結、孝親。
              </p>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mb-3">
                    <i className="ri-gamepad-line text-blue-600 text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">主題工作坊</h4>
                  <p className="text-sm text-gray-600">桌遊、歷奇、藝術創作、情境劇場、動漫</p>
                </div>
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mb-3">
                    <i className="ri-time-line text-green-600 text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">彈性實施</h4>
                  <p className="text-sm text-gray-600">週會、入班小組、半天工作坊、訓練營</p>
                </div>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl">
                <h4 className="font-semibold text-gray-900 mb-3">12個核心價值觀</h4>
                <div className="grid grid-cols-3 gap-3 text-sm">
                  <span className="bg-white px-3 py-2 rounded-lg text-center">堅毅</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">尊重</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">責任</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">國民身份認同</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">承擔</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">誠信</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">仁愛</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">守法</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">同理心</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">勤勞</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">團結</span>
                  <span className="bg-white px-3 py-2 rounded-lg text-center">孝親</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Kimochis Section */}
      <section id="kimochis" className="py-20 px-6 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Kimochis情緒管理和社交課程</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              美國專業設計的情緒教育課程，幫助孩子認識情緒、學會表達和管理
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">國際認證課程</h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                Kimochis®教材由美國教育專家Ellen P. Dodge設計，曾獲多個國際獎項，
                於美國及澳洲廣泛為學校及家長使用。
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-emotion-line text-purple-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">情緒認知</h4>
                    <p className="text-gray-600">透過擁有不同情緒特徵的角色，讓孩子透過這些角色代入不同情境</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-group-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">社交技巧</h4>
                    <p className="text-gray-600">認識不同情緒，以及不同程度的情緒會產生哪些表現和行為</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-heart-line text-green-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">自我管理</h4>
                    <p className="text-gray-600">從中了解自己的情緒變化，從而學會反思自身的行為</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-purple-100 to-pink-100 p-6 rounded-xl">
                <h4 className="font-semibold text-gray-900 mb-3">課程特色</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center space-x-2">
                    <i className="ri-check-line text-green-600"></i>
                    <span>互動式學習體驗</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <i className="ri-check-line text-green-600"></i>
                    <span>角色扮演和情境模擬</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <i className="ri-check-line text-green-600"></i>
                    <span>適合不同年齡層學生</span>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Colorful%20emotional%20learning%20characters%20and%20toys%20for%20children%2C%20Kimochis%20emotional%20education%20materials%2C%20cute%20cartoon%20characters%20representing%20different%20emotions%2C%20interactive%20learning%20tools%20for%20social%20emotional%20development%2C%20Hong%20Kong%20Chinese%20Asian%20children%20using%20materials%2C%20happy%20learning%20Hong%20Kong%20faces&width=600&height=500&seq=kimochishk1&orientation=landscape"
                alt="Kimochis情緒管理課程"
                className="rounded-2xl shadow-lg object-cover w-full h-[500px] object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* SEN Support Section */}
      <section id="sen" className="py-20 px-6 bg-gradient-to-br from-green-50 to-teal-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">特別需要學生支援服務</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              藝術治療／遊戲治療輔導／支援服務
            </p>
          </div>

          {/* Quote Section */}
          <div className="bg-gradient-to-r from-blue-100 to-purple-100 p-8 rounded-2xl mb-16 text-center">
            <blockquote className="text-2xl font-medium text-gray-800 italic mb-4">
              "Enter into children's play and you will find the place where their minds, heart, and souls meet."
            </blockquote>
            <cite className="text-lg text-gray-600">- Virginia Axline</cite>
          </div>

          {/* Service Categories */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
              <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-palette-line text-pink-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Art</h3>
              <p className="text-gray-600">透過藝術創作過程協助學生自我覺察，強化學習與適應能力</p>
            </div>
            
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
              <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-gamepad-line text-yellow-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Sand</h3>
              <p className="text-gray-600">沙盤讓學生在安全環境中表達內心世界</p>
            </div>
            
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-gamepad-2-line text-green-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Play</h3>
              <p className="text-gray-600">遊戲幫助學生外顯內在感受，處理內在矛盾/ 衝突， 亦可發展社交技能和情緒管理能力</p>
            </div>
          </div>

          {/* Main Content */}
          <div className="bg-gradient-to-br from-blue-900 to-purple-900 text-white p-12 rounded-3xl mb-16">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold mb-6 text-yellow-300">特別需要學生支援服務</h2>
              <h3 className="text-2xl mb-8 text-yellow-200">藝術治療／遊戲治療輔導／支援服務</h3>
            </div>

            <div className="max-w-4xl mx-auto text-lg leading-relaxed mb-12">
              <p className="mb-6">
                當兒童情緒不穩，以哭鬧、沉默或以不當的行為表達其情緒時，單單透過言語有時難以了解到兒童真實
                的聲音，一方面是可能因為他們不善於言語表達，另方面其他們自己也不理解自己內在複雜的內心感
                受。遊戲是兒童最熟悉的語言，透過遊戲／藝術介入，我們讓兒童安全自由地在遊戲過程中探索和表達自
                己的感受，並在過程中運用孩子的內在資源，讓他們自己找到解決的辦法，透過個別輔導，希望協助有
                需要的學生，讓他們能夠更快樂學習。
              </p>
            </div>

            {/* Service Details */}
            <div className="grid md:grid-cols-4 gap-8 text-center">
              <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm">
                <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-calendar-line text-blue-900 text-2xl"></i>
                </div>
                <h4 className="font-bold text-yellow-300 mb-2">時數</h4>
                <p className="text-white">12-24節</p>
              </div>
              
              <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm">
                <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-blue-900 text-2xl"></i>
                </div>
                <h4 className="font-bold text-yellow-300 mb-2">時間</h4>
                <p className="text-white">每節40分鐘</p>
              </div>
              
              <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm">
                <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-group-line text-blue-900 text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">形式</h3>
                <p className="text-gray-600">小組(不多於3人)<br/>個人輔導</p>
              </div>
              
              <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm">
                <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-blue-900 text-2xl"></i>
                </div>
                <h4 className="font-bold text-yellow-300 mb-2">服務/時間</h4>
                <p className="text-white">會提供專業的教材和輔助器材<br/>在學校進行中的服務</p>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">專業SEN支援</h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                透過專注力主題桌遊，以遊戲機制升學化訓練學生持續性注意力、選擇性注意力及抗干擾能力，
                讓學生在樂趣中有效提升專注效能。
              </p>
              
              <div className="grid grid-cols-1 gap-4">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                      <i className="ri-palette-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">藝術治療</h4>
                      <p className="text-gray-600">以非語言藝術創作（繪畫、黏土、音樂、戲劇等）為媒介，透過創作過程協助自我覺察，強化自我學習與適應能力。</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                      <i className="ri-group-2-line text-blue-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">社交技能發展訓練</h4>
                      <p className="text-gray-600">透過「社交情境演練」、「思考解讀」及「視覺化活動」，針對語言、情緒解讀、同理心提升等技巧。</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                      <i className="ri-graduation-cap-line text-purple-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">升中適應</h4>
                      <p className="text-gray-600">結合升中情境模擬與成長思維機制，引導學生將挫折視為成長機會，透過策略性作業提升自我效能。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Special%20educational%20needs%20Hong%20Kong%20Chinese%20Asian%20students%20participating%20in%20structured%20board%20game%20activities%2C%20inclusive%20learning%20environment%20with%20colorful%20educational%20materials%2C%20supportive%20teacher%20guidance%2C%20social%20skills%20development%20through%20play-based%20learning%2C%20focused%20happy%20Hong%20Kong%20faces&width=600&height=500&seq=senhk1&orientation=landscape"
                alt="SEN特殊學習需要支援"
                className="rounded-2xl shadow-lg object-cover w-full h-[500px] object-top"
              />
            </div>
          </div>

          <div className="bg-gradient-to-r from-green-100 to-teal-100 p-8 rounded-2xl">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">SEN桌遊社交課程</h3>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                針對特殊學習需要學生設計，透過結構化桌遊活動在安全有趣的環境中自然練習輸輸、規則理解、情緒調適及團隊協作
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white p-6 rounded-xl">
                <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
                  <i className="ri-gamepad-2-line text-green-600 mr-3 text-xl"></i>
                  SEN桌遊社交課程
                </h4>
                <p className="text-gray-600 mb-4">
                  透過專注力主題桌遊，以遊戲機制升學化訓練學生持續性注意力、選擇性注意力及抗干擾能力，
                  讓學生在樂趣中有效提升專注效能。
                </p>
                <div className="space-y-2">
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span>結構化遊戲設計</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span>專注力訓練</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span>社交技能提升</span>
                  </div>
                </div>
              </div>
              
              <div className="bg-white p-6 rounded-xl">
                <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
                  <i className="ri-focus-3-line text-blue-600 mr-3 text-xl"></i>
                  SEN專注力訓練桌遊小組
                </h4>
                <p className="text-gray-600 mb-4">
                  透過專注力主題桌遊，以遊戲機制升學化訓練學生持續性注意力、選擇性注意力及抗干擾能力，
                  讓學生在樂趣中有效提升專注效能。
                </p>
                <div className="space-y-2">
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span>持續性注意力訓練</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span>選擇性注意力提升</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span>抗干擾能力強化</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Positive Psychology Section */}
      <section id="positive-psychology" className="py-20 px-6 bg-gradient-to-br from-yellow-50 to-orange-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">正向心理學服務理論基礎</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              小組/工作坊/全年價值主題訓練/訓練營均可
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Colorful%20positive%20psychology%20concept%20illustration%20with%20happy%20Hong%20Kong%20Chinese%20Asian%20students%20learning%20about%20growth%20mindset%2C%20strengths%2C%20positive%20emotions%2C%20wellbeing%20and%20happiness%2C%20bright%20educational%20environment%20with%20positive%20thinking%20symbols%2C%20cheerful%20Asian%20faces%2C%20natural%20lighting&width=600&height=500&seq=positivepsych1&orientation=landscape"
                alt="正向心理學服務理論基礎"
                className="rounded-2xl shadow-lg object-cover w-full h-[500px] object-top"
              />
            </div>
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">培養正向思維</h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                基於正向心理學理論，透過多元化活動培養學生的正向思維和積極人生態度，
                幫助學生認識自己的優點特質，建立正向情緒和幸福感。
              </p>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center mb-3">
                    <i className="ri-star-line text-pink-600 text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">認識優點特質</h4>
                  <p className="text-sm text-gray-600">幫助學生發現和發展個人優勢</p>
                </div>
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center mb-3">
                    <i className="ri-emotion-happy-line text-yellow-600 text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">正向情緒</h4>
                  <p className="text-sm text-gray-600">培養積極樂觀的情緒狀態</p>
                </div>
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mb-3">
                    <i className="ri-heart-3-line text-orange-600 text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">幸福感</h4>
                  <p className="text-sm text-gray-600">提升整體生活滿足感和快樂感</p>
                </div>
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mb-3">
                    <i className="ri-chat-smile-3-line text-blue-600 text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">正向言語</h4>
                  <p className="text-sm text-gray-600">學習使用積極正面的表達方式</p>
                </div>
              </div>
            </div>
          </div>

          {/* Eight Core Elements */}
          <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-12 rounded-3xl mb-16">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">八大核心元素</h3>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                透過系統性的正向心理學訓練，全面提升學生的心理素質和生活品質
              </p>
            </div>

            <div className="grid md:grid-cols-4 gap-6 mb-12">
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-star-line text-pink-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">認識優點特質</h4>
                <p className="text-sm text-gray-600">發掘個人獨特優勢和才能</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-emotion-happy-line text-yellow-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">正向情緒</h4>
                <p className="text-sm text-gray-600">培養樂觀積極的情感狀態</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-3-line text-orange-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">幸福感</h4>
                <p className="text-sm text-gray-600">提升整體生活滿足感</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-chat-smile-3-line text-blue-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">正向言語</h4>
                <p className="text-sm text-gray-600">學習積極正面的表達</p>
              </div>
            </div>

            <div className="grid md:grid-cols-4 gap-6">
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-green-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">正向關係</h4>
                <p className="text-sm text-gray-600">建立健康和諧的人際關係</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-target-line text-purple-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">個人價值/目標訂立</h4>
                <p className="text-sm text-gray-600">確立人生方向和價值觀</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-gift-line text-red-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">讚美</h4>
                <p className="text-sm text-gray-600">學會欣賞和感謝他人</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-plant-line text-indigo-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">成長型思維</h4>
                <p className="text-sm text-gray-600">培養持續學習和成長的心態</p>
              </div>
            </div>
          </div>

          {/* Implementation Methods */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">實施方式</h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                我們提供多元化的實施方案，包括小組活動、工作坊、全年價值主題訓練和訓練營，
                靈活配合學校的不同需要和時間安排。
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-group-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">小組活動</h4>
                    <p className="text-gray-600">小班制互動學習，深度體驗正向心理學概念</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-presentation-line text-green-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">主題工作坊</h4>
                    <p className="text-gray-600">針對特定主題的深入學習和實踐</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-calendar-line text-purple-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">全年價值主題訓練</h4>
                    <p className="text-gray-600">系統性的年度培訓計劃，持續強化正向思維</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-tent-line text-orange-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">訓練營</h4>
                    <p className="text-gray-600">密集式體驗學習，快速建立正向心理素質</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20students%20participating%20in%20positive%20psychology%20workshop%20activities%2C%20diverse%20group%20of%20Asian%20children%20learning%20about%20growth%20mindset%20and%20positive%20thinking%2C%20interactive%20classroom%20setting%20with%20colorful%20educational%20materials%2C%20Asian%20faces&width=600&height=500&seq=positive2&orientation=landscape"
                alt="正向心理學活動"
                className="rounded-2xl shadow-lg object-cover w-full h-[500px] object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Other Support Groups Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-amber-50 to-yellow-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">其他支援小組</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              為不同年齡層和特殊需要的學生提供專業的小組支援服務
            </p>
          </div>

          {/* Special Learning Needs Support */}
          <div className="bg-gradient-to-r from-pink-100 to-red-100 p-12 rounded-3xl mb-16">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">特殊學習需要</h3>
              <div className="flex justify-center items-center space-x-8 mb-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-pink-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-group-line text-pink-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">適合對象</span>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-yellow-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-user-line text-yellow-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">幼兒</span>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-graduation-cap-line text-blue-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">小學生</span>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-purple-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-book-line text-purple-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">中學生</span>
                </div>
              </div>
            </div>

            <div className="grid lg:grid-cols-2 gap-12">
              <div className="space-y-6">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-focus-3-line text-orange-600 mr-3 text-xl"></i>
                    自閉症學生社交小組 (ASD)
                  </h4>
                  <p className="text-gray-600 mb-4">專為自閉症學生設計的社交技能訓練小組，透過結構化活動提升社交互動能力。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm">社交技能</span>
                    <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm">溝通訓練</span>
                    <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm">情緒管理</span>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-focus-line text-blue-600 mr-3 text-xl"></i>
                    情緒管理小組(ADHD/ASD)
                  </h4>
                  <p className="text-gray-600 mb-4">針對ADHD和ASD學生的情緒調節訓練，學習自我控制和情緒表達技巧。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">情緒調節</span>
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">自我控制</span>
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">行為管理</span>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-focus-2-line text-green-600 mr-3 text-xl"></i>
                    專注力及執行功能訓練小組(ADHD)
                  </h4>
                  <p className="text-gray-600 mb-4">透過專門設計的活動和遊戲，提升ADHD學生的專注力和執行功能。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">專注力訓練</span>
                    <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">執行功能</span>
                    <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">時間管理</span>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-chat-3-line text-purple-600 mr-3 text-xl"></i>
                    溝通及高功能訓練小組(ASD)
                  </h4>
                  <p className="text-gray-600 mb-4">為高功能自閉症學生提供進階溝通技巧和社交能力訓練。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-sm">高階溝通</span>
                    <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-sm">社交推理</span>
                    <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-sm">情境理解</span>
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-book-read-line text-indigo-600 mr-3 text-xl"></i>
                    讀寫障礙英文小組
                  </h4>
                  <p className="text-gray-600 mb-4">專為讀寫障礙學生設計的英文學習支援小組，採用多感官教學法。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm">多感官教學</span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm">拼音訓練</span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm">閱讀理解</span>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-translate-2 text-red-600 mr-3 text-xl"></i>
                    讀寫障礙中文小組
                  </h4>
                  <p className="text-gray-600 mb-4">針對中文讀寫困難的學生，提供系統性的中文學習支援和策略訓練。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm">中文識字</span>
                    <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm">筆順練習</span>
                    <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm">語文理解</span>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-palette-line text-pink-600 mr-3 text-xl"></i>
                    藝術治療小組/形象粉彩/多元藝術訓練
                  </h4>
                  <p className="text-gray-600 mb-4">透過藝術創作活動，幫助學生表達情感、提升自信和創造力。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-pink-100 text-pink-700 px-3 py-1 rounded-full text-sm">藝術治療</span>
                    <span className="bg-pink-100 text-pink-700 px-3 py-1 rounded-full text-sm">情感表達</span>
                    <span className="bg-pink-100 text-pink-700 px-3 py-1 rounded-full text-sm">創意發展</span>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-gamepad-line text-teal-600 mr-3 text-xl"></i>
                    Boardgame多元提升小組
                  </h4>
                  <p className="text-gray-600 mb-4">運用桌遊活動提升學生的認知能力、社交技巧和問題解決能力。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm">策略思考</span>
                    <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm">團隊合作</span>
                    <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm">邏輯推理</span>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-body-scan-line text-amber-600 mr-3 text-xl"></i>
                    靜觀訓練
                  </h4>
                  <p className="text-gray-600 mb-4">教導學生靜觀技巧，提升專注力、情緒調節和內在平靜。</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-sm">靜觀練習</span>
                    <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-sm">情緒平衡</span>
                    <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-sm">專注提升</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Individual Growth Programs */}
          <div className="bg-gradient-to-r from-blue-100 to-purple-100 p-12 rounded-3xl mb-16">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">個人成長</h3>
              <div className="flex justify-center items-center space-x-8 mb-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-user-line text-blue-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">幼兒</span>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-purple-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-graduation-cap-line text-purple-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">小學生</span>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-indigo-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-book-line text-indigo-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">中學生</span>
                </div>
              </div>
            </div>

            <div className="grid lg:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-chat-smile-line text-blue-600 mr-3"></i>
                    面對失敗工作坊
                  </h4>
                  <p className="text-gray-600 text-sm">幫助學生面對生活挑戰，建立抗逆力和正向思維。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-emotion-line text-green-600 mr-3"></i>
                    情緒思維訓練小組/工作坊
                  </h4>
                  <p className="text-gray-600 text-sm">提升情緒智商，學習情緒管理和思維調節技巧。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-chat-3-line text-purple-600 mr-3"></i>
                    情緒管理小組
                  </h4>
                  <p className="text-gray-600 text-sm">系統性的情緒管理訓練，提升自我調節能力。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-heart-line text-red-600 mr-3"></i>
                    性教育小組/工作坊
                  </h4>
                  <p className="text-gray-600 text-sm">年齡適宜的性教育課程，建立健康的性觀念。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-team-line text-orange-600 mr-3"></i>
                    環保工作坊
                  </h4>
                  <p className="text-gray-600 text-sm">透過環保教育活動，提升學生的環保意識和責任感。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-group-line text-teal-600 mr-3"></i>
                    社交小組
                  </h4>
                  <p className="text-gray-600 text-sm">提升社交技巧，建立良好的人際關係。</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-palette-line text-pink-600 mr-3"></i>
                    藝術治療小組
                  </h4>
                  <p className="text-gray-600 text-sm">透過藝術創作進行心理治療和情感表達。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-gamepad-line text-indigo-600 mr-3"></i>
                    Boardgame多元提升小組
                  </h4>
                  <p className="text-gray-600 text-sm">運用桌遊提升認知、社交和策略思考能力。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-body-scan-line text-amber-600 mr-3"></i>
                    靜觀訓練/正面療法
                  </h4>
                  <p className="text-gray-600 text-sm">結合靜觀練習和正面心理治療技巧。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-heart-pulse-line text-green-600 mr-3"></i>
                    身心靈小組
                  </h4>
                  <p className="text-gray-600 text-sm">全人發展課程，平衡身心靈健康。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-mental-health-line text-purple-600 mr-3"></i>
                    領袖訓練小組/工作坊
                  </h4>
                  <p className="text-gray-600 text-sm">培養領導能力和團隊管理技巧。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-magic-line text-blue-600 mr-3"></i>
                    壓力管理工作坊
                  </h4>
                  <p className="text-gray-600 text-sm">學習有效的壓力管理技巧，提升心理韌性。</p>
                </div>
              </div>
            </div>
          </div>

          {/* Teacher Development */}
          <div className="bg-gradient-to-r from-orange-100 to-red-100 p-12 rounded-3xl mb-16">
            <div className="text-center mb-8">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">教師發展日/培訓</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-lightbulb-line text-orange-600 mr-3"></i>
                    團隊活動
                  </h4>
                  <p className="text-gray-600">提升教師團隊凝聚力和協作能力的專業發展活動。</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-presentation-line text-red-600 mr-3"></i>
                    靜觀活動
                  </h4>
                  <p className="text-gray-600">幫助教師減壓放鬆，提升工作效能和身心健康。</p>
                </div>
              </div>
            </div>
          </div>

          {/* Family Education Courses */}
          <div className="bg-gradient-to-r from-green-100 to-teal-100 p-12 rounded-3xl mb-16">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">家長教育課程</h3>
              <p className="text-lg text-gray-600 mb-8">
                (配合《家長教育課程架構》的理念和原則)
              </p>
              <div className="flex justify-center items-center space-x-8 mb-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-green-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-user-line text-green-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">幼兒</span>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-graduation-cap-line text-teal-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">小學生</span>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-200 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-book-line text-blue-600 text-2xl"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">中學生</span>
                </div>
              </div>
            </div>

            <div className="grid lg:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-parent-line text-green-600 mr-3"></i>
                    親子管教法
                  </h4>
                  <p className="text-gray-600 text-sm">學習有效的管教策略，建立正面的親子關係。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-heart-line text-red-600 mr-3"></i>
                    正向心理學教法
                  </h4>
                  <p className="text-gray-600 text-sm">運用正向心理學原理，培養孩子的正面思維。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-brain-line text-purple-600 mr-3"></i>
                    正向心理學與管教法
                  </h4>
                  <p className="text-gray-600 text-sm">結合正向心理學與管教技巧的綜合課程。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-gamepad-line text-blue-600 mr-3"></i>
                    點同仔女玩
                  </h4>
                  <p className="text-gray-600 text-sm">學習如何透過遊戲與孩子建立更深的連結。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-chat-3-line text-teal-600 mr-3"></i>
                    親子溝通法
                  </h4>
                  <p className="text-gray-600 text-sm">提升親子溝通技巧，增進家庭和諧。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-emotion-line text-orange-600 mr-3"></i>
                    如何處理子女情緒問題
                  </h4>
                  <p className="text-gray-600 text-sm">學習識別和處理孩子的情緒困擾。</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-home-line text-indigo-600 mr-3"></i>
                    家長減壓工作坊
                  </h4>
                  <p className="text-gray-600 text-sm">幫助家長學習壓力管理和自我照顧技巧。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-mental-health-line text-pink-600 mr-3"></i>
                    家長靜觀/身心靈課程
                  </h4>
                  <p className="text-gray-600 text-sm">透過靜觀練習提升家長的身心健康。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-palette-line text-amber-600 mr-3"></i>
                    藝術治療小組
                  </h4>
                  <p className="text-gray-600 text-sm">為家長提供藝術治療體驗，釋放壓力。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-emotion-happy-line text-green-600 mr-3"></i>
                    情緒控制/EQ提升班
                  </h4>
                  <p className="text-gray-600 text-sm">提升家長的情緒智商和自我管理能力。</p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-group-2-line text-purple-600 mr-3"></i>
                    點同仔女Friend
                  </h4>
                  <p className="text-gray-600 text-sm">學習如何成為孩子的朋友和支持者。</p>
                </div>
              </div>
            </div>
          </div>

          {/* SEN Student Support */}
          <div className="bg-gradient-to-r from-yellow-100 to-orange-100 p-12 rounded-3xl">
            <div className="text-center mb-8">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">SEN學生心聲</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
                      <i className="ri-heart-line text-yellow-600 text-xl"></i>
                    </div>
                    <div>
                      <p className="text-gray-700 mb-4">
                        "自信心多左，以前覺得自己好無用，而家有信心，努力讀書。"
                      </p>
                      <p className="text-sm text-gray-500">- SEN學生分享</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                      <i className="ri-group-line text-orange-600 text-xl"></i>
                    </div>
                    <div>
                      <p className="text-gray-700 mb-4">
                        "學識點同人做朋友，點達鍊話題，有多啲朋友。"
                      </p>
                      <p className="text-sm text-gray-500">- SEN學生分享</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl">
              <h4 className="font-bold text-gray-900 mb-6 text-center">專業團隊支援</h4>
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h5 className="font-semibold text-gray-900 mb-4">導師為設過十年的註冊社工</h5>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-600 mr-2"></i>
                      教材團隊豐富年豐富度康復設計
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-600 mr-2"></i>
                      服務超過十年，可靈活心
                    </li>
                  </ul>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-4">服務完結會提供活動策劃效果報告</h5>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-600 mr-2"></i>
                      服務完結會提供活動策劃效果報告
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Parent-Child Activities Section */}
      <section id="parent-child" className="py-20 px-6 bg-gradient-to-br from-rose-50 to-orange-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-red-500 to-orange-500 text-white px-8 py-3 rounded-full font-bold text-lg mb-6 transform -rotate-2">
              <i className="ri-star-fill mr-2"></i>
              RECOMMENDED
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">親子活動</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              適合對象：幼兒、幼稚園、小學生、中學生
            </p>
          </div>

          {/* Activities Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {parentChildActivities.map((activity, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="relative h-64">
                  <img 
                    src={activity.image}
                    alt={activity.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className={`absolute top-4 right-4 w-14 h-14 bg-${activity.color}-100 rounded-full flex items-center justify-center`}>
                    <i className={`${activity.icon} text-${activity.color}-600 text-2xl`}></i>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{activity.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{activity.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Benefits Section */}
          <div className="bg-gradient-to-r from-orange-100 to-pink-100 p-12 rounded-3xl">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">親子活動的好處</h3>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                透過多元化的親子活動，增進家庭關係，促進孩子全面發展
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-parent-line text-blue-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">增進親子關係</h4>
                <p className="text-sm text-gray-600">透過共同參與活動，建立更深厚的情感連結</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-emotion-happy-line text-green-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">培養正向情緒</h4>
                <p className="text-sm text-gray-600">在愉快的氛圍中學習，提升孩子的幸福感</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-purple-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">提升溝通技巧</h4>
                <p className="text-sm text-gray-600">學習有效表達和聆聽，改善家庭溝通</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-3-line text-pink-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">建立美好回憶</h4>
                <p className="text-sm text-gray-600">創造珍貴的家庭時光和難忘的經歷</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-12 rounded-3xl">
              <h3 className="text-3xl font-bold mb-4">立即報名參加親子活動</h3>
              <p className="text-xl mb-8 opacity-90">
                讓我們一起創造美好的親子時光，為孩子的成長添上精彩的一頁！
              </p>
              <a href="#contact" className="bg-white text-blue-600 px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer shadow-lg inline-block">
                <i className="ri-calendar-check-line mr-2"></i>
                立即查詢
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Interest Classes Section */}
      <section id="interest-classes" className="py-20 px-6 bg-gradient-to-br from-indigo-50 to-purple-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-purple-500 to-indigo-500 text-white px-8 py-3 rounded-full font-bold text-lg mb-6 transform rotate-2">
              <i className="ri-star-fill mr-2"></i>
              多元興趣班
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">豐富多彩的興趣班課程</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              中心亦提供不同類型的興趣班，不能盡錄，歡迎查詢及報價
            </p>
          </div>

          {/* Interest Classes Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {interestClasses.map((course, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:scale-105">
                <div className="relative h-64">
                  <img 
                    src={course.image}
                    alt={course.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className={`absolute top-4 right-4 w-14 h-14 bg-${course.color}-100 rounded-full flex items-center justify-center backdrop-blur-sm`}>
                    <i className={`${course.icon} text-${course.color}-600 text-2xl`}></i>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                    <h3 className="text-xl font-bold text-white mb-2">{course.title}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 leading-relaxed text-sm">{course.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Special Highlights */}
          <div className="bg-gradient-to-r from-purple-100 to-indigo-100 p-12 rounded-3xl mb-16">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">興趣班特色</h3>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                我們的興趣班課程設計多元化，既能培養學生的興趣愛好，又能提升各方面的能力
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-purple-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">創意發展</h4>
                <p className="text-sm text-gray-600">透過各種藝術和手工活動激發創意潛能</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-pulse-line text-green-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">身心健康</h4>
                <p className="text-sm text-gray-600">運動課程促進身體健康和心理平衡</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-blue-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">社交互動</h4>
                <p className="text-sm text-gray-600">小組活動增進同儕互動和合作能力</p>
              </div>
              
              <div className="bg-white p-6 rounded-xl text-center shadow-sm">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-trophy-line text-orange-600 text-2xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">技能培養</h4>
                <p className="text-sm text-gray-600">學習實用技能，建立成就感和自信心</p>
              </div>
            </div>
          </div>

          {/* Popular Classes Showcase */}
          <div className="grid lg:grid-cols-3 gap-8 mb-16">
            <div className="lg:col-span-2">
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">熱門課程推薦</h3>
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                      <i className="ri-music-line text-purple-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">跳舞Jazz/K-pop</h4>
                      <p className="text-gray-600 text-sm">最受歡迎的舞蹈課程，結合現代流行元素，讓學生在音樂中展現活力與自信。</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                      <i className="ri-palette-line text-orange-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">各式手工藝</h4>
                      <p className="text-gray-600 text-sm">包括扎染、編織、陶藝等多種手工藝製作，培養學生的動手能力和藝術素養。</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
                      <i className="ri-gamepad-2-line text-indigo-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Boardgame桌遊</h4>
                      <p className="text-gray-600 text-sm">透過各種桌遊活動，提升學生的邏輯思維、策略規劃和社交技巧。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="bg-gradient-to-br from-pink-100 to-red-100 p-6 rounded-xl">
                <div className="text-center mb-4">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-boxing-line text-red-600 text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">泰拳課程</h4>
                </div>
                <p className="text-gray-700 text-sm text-center">
                  專業泰拳訓練，不僅強身健體，更能培養堅毅意志和自律精神。
                </p>
              </div>
              
              <div className="bg-gradient-to-br from-teal-100 to-green-100 p-6 rounded-xl">
                <div className="text-center mb-4">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-leaf-line text-teal-600 text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">香薰製品</h4>
                </div>
                <p className="text-gray-700 text-sm text-center">
                  學习製作天然香薰產品，培養環保意識和生活美學。
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-12 rounded-3xl">
              <h3 className="text-3xl font-bold mb-4">立即報名參加興趣班</h3>
              <p className="text-xl mb-8 opacity-90">
                多元化課程選擇，專業導師指導，為學生提供全面發展的學習機會！
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="#contact" className="border-2 border-white text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-line mr-2"></i>
                  立即查詢報價
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">專業服務項目</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我們為不同教育階段提供專業培訓服務，包括幼稚園、小學、中學，
              以及企業培訓和SEN特殊學習需要支援，全方位支援教育發展需要。
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              {services.map((service, index) => (
                <div 
                  key={index}
                  className={`p-6 rounded-xl cursor-pointer transition-all duration-300 ${
                    activeService === index 
                      ? 'bg-blue-50 border-2 border-blue-200 shadow-lg' 
                      : 'bg-gray-50 border-2 border-transparent hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveService(index)}
                >
                  <div className="flex items-start space-x-4">
                    <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                      activeService === index ? 'bg-blue-600' : 'bg-gray-400'
                    }`}>
                      <i className={`text-white text-xl ${
                        index === 0 ? 'ri-team-line' :
                        index === 1 ? 'ri-medal-line' :
                        index === 2 ? 'ri-emotion-happy-line' :
                        index === 3 ? 'ri-heart-add-line' :
                        index === 4 ? 'ri-lightbulb-line' :
                        index === 5 ? 'ri-parent-line' :
                        index === 6 ? 'ri-graduation-cap-line' :
                        'ri-building-line'
                      }`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.title}</h3>
                      <p className="text-gray-600">{service.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-2xl">
              <div className="mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{services[activeService].title}</h3>
                <p className="text-gray-600 mb-6">{services[activeService].description}</p>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mb-8">
                {services[activeService].features.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </div>
                ))}
              </div>

              <img 
                src={`https://readdy.ai/api/search-image?query=${
                  activeService === 0 ? 'Hong Kong Chinese students participating in group training activities, teamwork and collaboration, educational workshop setting, engaging and interactive learning environment, Asian faces' :
                  activeService === 1 ? 'Hong Kong Chinese students learning moral values and character education, interactive classroom activities with 12 core values elements, educational poster and materials, Asian faces' :
                  activeService === 2 ? 'Hong Kong Chinese children learning emotional management with colorful Kimochis characters, social emotional learning classroom, interactive emotional education activities, Asian faces' :
                  activeService === 3 ? 'Special educational needs Hong Kong Chinese students in supportive learning environment, inclusive classroom with specialized teaching materials, SEN support services and adaptive learning tools, Asian faces' :
                  activeService === 4 ? 'Hong Kong Chinese students learning positive psychology concepts, happiness and growth mindset activities, colorful educational materials about positive emotions and strengths, Asian faces' :
                  activeService === 5 ? 'Hong Kong Chinese parent education seminar, Asian parents listening to professional speaker, family education workshop, supportive learning environment, Asian faces' :
                  activeService === 6 ? 'Hong Kong Chinese teacher professional development training, Asian educators in workshop setting, professional learning environment, skill development session, Asian faces' :
                  'Hong Kong Chinese corporate training session, Asian business professionals in training room, team building activities, professional development workshop, Asian faces'
                }&width=500&height=300&seq=service${activeService}&orientation=landscape`}
                alt={services[activeService].title}
                className="rounded-xl object-cover w-full h-48 object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20Hong%20Kong%20Chinese%20Asian%20education%20consultants%20team%20meeting%2C%20experienced%20trainers%20discussing%20educational%20strategies%2C%20modern%20office%20environment%2C%20expertise%20and%20professionalism%2C%20confident%20professional%20Hong%20Kong%20faces&width=600&height=400&seq=abouthk1&orientation=landscape"
                alt="專業青年訓練團隊"
                className="rounded-2xl shadow-lg object-cover w-full h-96 object-top"
              />
            </div>
            <div className="space-y-6">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-4">關於青年創變</h2>
                <p className="text-xl text-gray-600 leading-relaxed mb-6">
                  青年創變有限公司成立多年來，一直致力於為香港教育界提供專業的青年訓練及學生培訓服務。
                  我們深信每個人都有改變世界的潛能，透過專業的青年訓練和指導，
                  培養新一代的領導人才和創新思維。我們的青年訓練課程結合理論與實踐，確保學生得到全面發展。
                </p>
              </div>

              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-lightbulb-line text-blue-600 text-xl"></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">創新教學</h3>
                  <p className="text-gray-600 text-sm">運用最新的教育理念和方法</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-user-star-line text-green-600 text-xl"></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">專業團隊</h3>
                  <p className="text-gray-600 text-sm">經驗豐富的教育專家</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-heart-line text-purple-600 text-xl"></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">用心服務</h3>
                  <p className="text-gray-600 text-sm">以學生成長為核心目標</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-trophy-line text-orange-600 text-xl"></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">卓越成果</h3>
                  <p className="text-gray-600 text-sm">獲得廣泛認可和好評</p>
                </div>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl">
                <h4 className="font-semibold text-gray-900 mb-3">我們的使命</h4>
                <p className="text-gray-700">
                  透過專業的青年訓練及教育培訓服務，啟發每個人的潛能，培養具備創新思維、
                  領導能力和社會責任感的未來領袖，為社會帶來正面的改變。我們的青年訓練課程結合理論與實踐，確保學生得到全面發展。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">客戶見證</h2>
            <p className="text-xl text-gray-600">來自學校、教師和家長的真實回饋</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-2xl">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-700 mb-6 leading-relaxed">"{testimonial.content}"</p>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 font-semibold">{testimonial.name[0]}</span>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">聯絡我們</h2>
            <p className="text-xl text-gray-600">歡迎查詢我們的服務，讓我們為您提供專業的教育培訓方案</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">聯絡資訊</h3>
                <div className="space-y-4">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                      <i className="ri-phone-line text-blue-600 text-xl"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">電話查詢</div>
                      <div className="text-gray-600">98211857</div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                      <i className="ri-mail-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">電郵聯絡</div>
                      <div className="text-gray-600">changemakersmail@gmail.com</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-4">關注我們</h4>
                <div className="flex space-x-4">
                  <a href="#" className="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center hover:bg-pink-200 transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-pink-600 text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center hover:bg-blue-200 transition-colors cursor-pointer">
                    <i className="ri-facebook-fill text-blue-600 text-xl"></i>
                  </a>
                </div>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl">
                <h4 className="font-semibold text-gray-900 mb-3">服務時間</h4>
                <div className="space-y-2 text-gray-700">
                  <div>星期一至五：上午9時至下午6時</div>
                  <div>星期六：上午9時至下午1時</div>
                  <div>星期日及公眾假期：休息</div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">查詢表格</h3>
              <form 
                className="space-y-6" 
                action="https://readdy.ai/api/form/d4cj1u1pkd5ovn9u5srg" 
                method="POST" 
                data-readdy-form
                id="contact_inquiry"
              >
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">姓名 *</label>
                    <input 
                      type="text" 
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="請輸入您的姓名"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">職位</label>
                    <input 
                      type="text" 
                      name="position"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="例如：校長、老師、家長"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">學校/機構名稱</label>
                  <input 
                    type="text" 
                    name="organization"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="請輸入學校或機構名稱"
                  />
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">電話 *</label>
                    <input 
                      type="tel" 
                      name="phone"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="請輸入聯絡電話"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">電郵 *</label>
                    <input 
                      type="email" 
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="請輸入電郵地址"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">感興趣的服務</label>
                  <select name="service" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8">
                    <option value="">請選擇服務項目</option>
                    <option value="小組訓練活動">小組訓練活動</option>
                    <option value="教育局12個價值觀元素">教育局12個價值觀元素</option>
                    <option value="Kimochis情緒管理課程">Kimochis情緒管理課程</option>
                    <option value="SEN特殊學習需要支援">SEN特殊學習需要支援</option>
                    <option value="正向心理學服務">正向心理學服務</option>
                    <option value="親子活動">親子活動</option>
                    <option value="興趣班">興趣班</option>
                    <option value="家長講座">家長講座</option>
                    <option value="教師訓練">教師訓練</option>
                    <option value="企業培訓">企業培訓</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">查詢內容 *</label>
                  <textarea 
                    rows={4}
                    name="message"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                    placeholder="請詳細描述您的需求或查詢內容..."
                    maxLength={500}
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1">最多500字</div>
                </div>
                <button 
                  type="submit"
                  className="w-full bg-blue-600 text-white py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  提交查詢
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp 浮動按鈕 */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/85298211857"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110 flex items-center justify-center w-16 h-16 cursor-pointer"
          aria-label="聯絡我們 WhatsApp"
        >
          <i className="fab fa-whatsapp text-2xl"></i>
        </a>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-4 mb-6">
                <img 
                  src="https://static.readdy.ai/image/6b3080a7ad87d4828fdf666065d4a97a/47b8cf5cc7d4e26c3fd48cdb40a3e5db.png" 
                  alt="青年創變有限公司 Changemakers Limited 青年訓練專家" 
                  className="h-32 w-auto filter brightness-0 invert"
                />
                <div className="text-2xl font-bold">
                  青年創變有限公司
                  <div className="text-lg font-normal text-gray-300">Changemakers Limited</div>
                </div>
              </div>
              <p className="text-gray-400 mb-6 max-w-md">
                致力培養新一代的領導人才和創新思維，為香港教育界提供專業的青年訓練及學生培訓服務。
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-gray-300"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-gray-300"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">服務項目</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">青年訓練活動</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">學生培訓課程</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">價值觀教育</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">情緒管理課程</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">SEN支援服務</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">家長講座</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">教師訓練</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">企業培訓</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-2 text-gray-400">
                <li>電話：98211857</li>
                <li>電郵：changemakersmail@gmail.com</li>
                <li>服務時間：週一至五 9:00-18:00</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 青年創變有限公司 Changemakers Limited. 版權所有。
            </p>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
